import { Component, OnInit } from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import { ParamMap, Router, ActivatedRoute,Params } from '@angular/router';
import { pgService } from '../../service/pg.service';
import {Globals } from '../../globals';

@Component({
  selector: 'app-trandingpg',
  templateUrl: './trandingpg.component.html',
  styleUrls: ['./trandingpg.component.css'],
  providers:[pgService,Globals]
})
export class TrandingpgComponent implements OnInit {
  trandingList:any;
  msg='';

  constructor(private router: Router,private route: ActivatedRoute,private _pg:pgService,private global: Globals) { }

  ngOnInit() {
    this.getTrandingPG();
  }

  getTrandingPG(){
    let obj={};
    obj['limit']=10;
    obj['offset']=0;
    this._pg.getTrandingPG(obj).subscribe((data:any)=>{

      if(data.error==0){
        //console.log('fgdfgfdgdf');
        //console.log(data);
         // console.log(data.results);
        this.trandingList=data.results.rows;
      //  console.log(this.trandingList);
      }
      

    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
    })
    
  }

  detailpg(pgId){
    let encodeUrl:any;
    //this.router.navigateByUrl('/pgdetail?cid='+btoa(pgId));
    //var encodeUrl="cid='+btoa(pgId)+'&lat='+btoa(this.lat)+'&lng='+btoa(this.lng)";
    encodeUrl="cid="+pgId+"&lat=&lng=&bhk=&add=&city=";
    encodeUrl=encodeURIComponent(encodeUrl);
    window.open(this.global.websiteUrl+'pgdetail?searchparam='+btoa(encodeUrl)); 
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/trandingpg/trandingpg.component.ts